export const SupportCouponModeMap = {
  banner: 'banner',
  form: 'form',
  unset: 'unset',
}
